import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'
import { formatedDate } from '../../utils/formatedDate'

export let returnNoFilter;
let orderNoFilter;
let shippingOrderNoFilter;
let customerFilter
let storehouseCoordinatesOrNameFilter;
//let officeDisplayNameFilter;
//let costCenterDisplayNameFilter;

export function clearFilter() {
    returnNoFilter(null)
    orderNoFilter(null)
    shippingOrderNoFilter(null)
    customerFilter(null)
    storehouseCoordinatesOrNameFilter(null)
    //officeDisplayNameFilter(null)
    //costCenterDisplayNameFilter(null)
}
export const columns = [
  {
    dataField: 'checkBox',
    text: '',
    sort: false,
    editable: false,
    headerClasses: 'checkBox-header-cell',
    classes: 'checkBox-cell'
  },
  {
    dataField: 'displayName',
    text: 'returnsTable:receiptNo',
    sort: true,
    editable: false,
    filterKey: 'filter.returnNo',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { returnNoFilter = filter }} />,
  },
  {
    dataField: 'order.orderNr',
    text: 'returnsTable:orderNo',
    sort: true,
    editable: false,
    filterKey: 'filter.orderNo',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { orderNoFilter = filter }} />,
  },
  {
    dataField: 'shippingOrder.ShippingOrderNumber',
    text: 'returnsTable:shippingOrderNo',
    sort: true,
    editable: false,
    filterKey: 'filter.shippingOrderNo',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { shippingOrderNoFilter = filter }} />,
  },
  {
    dataField: 'customer.displayName',
    text: 'returnsTable:customer',
    sort: true,
    editable: false,
    filterKey: 'filter.customer',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { customerFilter = filter }} />,
  },
  /*{
    dataField: 'office.displayName',
    text: 'orgaUnit',
    sort: true,
    filterKey: 'filter.officeDisplayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { officeDisplayNameFilter = filter }} />
  },*/
  /*{
    dataField: 'costCenter.displayName',
    text: 'costcenter',
    sort: true,
    filterKey: 'filter.costCenterDisplayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { costCenterDisplayNameFilter = filter }} />,
    headerClasses: 'costcenter-header-cell',
    classes: 'costcenter-cell'
  },*/
  {
    dataField: 'positionCount.total',
    text: 'returnsTable:positionCount',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    /*formatter: (cell, row, rowIndex, extraProps) => (
        <>
          <div >
                {row.positionCount.total}{" ("}{row.positionCount.arrived}{"/"}{row.positionCount.stored}{")"}
          </div>
        </>
      ),*/
  },
  {
    dataField: 'expectedTimeOfArrival',
    text: 'returnsTable:expectedTimeOfArrival',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    formatter: (cell, row) => (formatedDate(cell))
  },
  {
    dataField: 'storehouse.displayName',
    text: 'returnsTable:warehouse',
    sort: true,
    editable: false,
    filterKey: 'filter.storehouseCoordinatesOrName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { storehouseCoordinatesOrNameFilter = filter }} />,
    formatter: (cell, row, rowIndex, extraProps) => (
      <>
        <div>{row.storehouse.displayName}</div>
        <small>{row.storehouse.coordinateCode}</small>
      </>
    ),
  },
  {
    dataField: 'actions',
    text: '',
    headerClasses: 'actions-header-cell',
    classes: 'actions-cell'
  }
];
